module.exports = __webpack_public_path__ + "static/media/keyoperation3.f1305797.png";